<template>
    <section class="content">
        <div class="box box-info">
            <div class="box box-body">
              <div id="billNo" v-if="purchaseHeaderObj.reportType == 'Invoice'" class="col-sm-3">
                  <label for="billNo">Bill No :</label>
                  <span  class="purchaseOutput "><b>{{purchaseHeaderObj.billNo}}</b></span>
              </div>
               <div id="challanNo" v-if="purchaseHeaderObj.reportType == 'Challan'" class="col-sm-3">
                  <label for="challanNo"  >Challan No :</label>
                  <span class="purchaseOutput "><b>{{purchaseHeaderObj.challanNo}}</b></span>
              </div>
               <div id="orderNo"  v-if="purchaseHeaderObj.reportType == 'Order'" class="col-sm-3">
                  <label for="orderNo" >Order No :</label>
                  <span  class="purchaseOutput "><b>{{purchaseHeaderObj.orderNo}}</b></span>
              </div>

              <div id="referenceNumber" class="col-sm-3 " style="margin-left: -12%;">
                    <label for="referenceNumber" >Reference No. :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.referenceNumber}} </b>
                    </span>
               </div>
               <div id="purchaseDate" class="col-sm-3" style="margin-left: -8%;">
                  <label for="purchaseDate" > Date :</label>
                  <span class="purchaseOutput"><b>{{purchaseHeaderObj.purchaseDate}}</b></span>
               </div>
               <div id="warehouseName" class="col-sm-3 " style="margin-left: -5%;">
                    <label for="WarehouseName" >Store :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.warehouse.name}} </b>
                    </span>
               </div>
               <div v-if="purchaseHeaderObj.reportType == 'Invoice'" id="warehouseName" class="col-sm-3 " style="margin-left: -1%;">
                    <label for="WarehouseName" >Bill Type :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.vatTypeEnum}} </b>
                    </span>
               </div>
                 <!-- <div  id="supp" class="col-sm-3 " style="margin-left: -1%;">
                    <label for="WarehouseName" >Supplier Type :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.supplierType}} </b>
                    </span>
               </div> -->
               <!-- <div  id="supp" class="col-sm-3 " style="margin-left: -1%;">
                    <label for="WarehouseName" >Shift :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.shift}} </b>
                    </span>
               </div> -->
               <div id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Customer :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.account.name}}</b>
                    </span>
               </div>
              <div v-show="purchaseHeaderObj.account.name=='Cash'" id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Bill From :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.account.billToName}}</b>
                    </span>
               </div>
                <div v-show="purchaseHeaderObj.account.name !='Cash'" id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Address :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.account.address}}</b>
                    </span>
               </div>
                <div v-show="purchaseHeaderObj.account.name !='Cash'" id="suppplier" class="col-sm-3" >
                    <label for="suppplier">Vat/Pan No :</label>
                    <span class="purchaseOutput ">
                      <b>{{purchaseHeaderObj.account.panNo}}</b>
                    </span>
               </div>

           <table class="table table-bordered " style="margin-top: 5%;">
            <thead >
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Item Name</th>
                <th scope="col">Quantity</th>
                <th scope="col">Fat%</th>
                <th scope="col">Fat Amount</th>
                <th scope="col">Snf%</th>
                <th scope="col">Snf Amount</th>
                <th scope="col">Ts%</th>
                <th scope="col">Ts Amount</th>
                <th scope="col">Extra</th>
                <th scope="col">Rate</th>
                <th scope="col">Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody  v-for="(pd,index) in inventoryInOutDetailList " :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{pd.name}}</td>
                <td>{{pd.quantity}}</td>
                 <td>{{pd.fatPercentage}}</td>
                  <td>{{pd.fatAmount}}</td>
                   <td>{{pd.snfPercentage}}</td>
                    <td>{{pd.snfAmount}}</td>
                    <td >{{pd.tsPercentage}}</td>
                    <td >{{pd.tsAmount}}</td>
                     <td>{{pd.rateAdjustment}}</td>
                <td>{{pd.rate}}</td>
                <td>{{(pd.quantity * pd.rate).toFixed(4)}} </td>
                 <div class="p-field p-col-12 p-md-2" >
                      <Button class="p-button-raised" @click.prevent="posDetail(pd)" icon="pi pi-eye"/>
                      </div>
              </tr>
            </tbody>
          </table>
          <div class="col-md-8" v-if="this.extraExpensesList.length>0">
            <h5>Extra Expenses</h5>
            <table class="table table-bordered " style="margin-top: 2%;">
            <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Name</th>
                <th scope="col">Amount</th>
                <th scope="col">Vatable</th>
                <th scope="col">Debit Account</th>
                <th scope="col">Credit Account</th>
              </tr>
            </thead>
            <tbody  v-for="(expenses,index) in extraExpensesList " :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{expenses.expensesName}}</td>
                <td>{{expenses.extraExpenseAmt}}</td>
                <td>{{expenses.applyVat}}</td>
                <td>{{expenses.debitAccountName}} </td>
                <td>{{expenses.creditAccountName}}</td>
              </tr>
            </tbody>
            </table>
          </div>
           <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <textarea type="text" rows="6" class="form-control"  v-model="purchaseHeaderObj.remarks"/>
         </div>
          <div class="col-xs-4 _total" v-if="purchaseHeaderObj.reportType == 'Invoice'"
          style="float:right; margin-right:-18%;margin-top:3%;">
            <label for="subttotal" >Subtotal: </label>
            <span id="subttotal" style="margin-left: 10%;"  class="_span">{{(purchaseHeaderObj.subTotalAmount).toFixed(4)}} </span>
            <br/>
            <label for="discountamt" >Discount Amt: </label>
            <span id="discountamt" style="margin-left: 3%;"  class="_span">{{purchaseHeaderObj.discountAmt}} </span>
            <br/>
            <label for="exciseDuty" >Excise Charge: </label>
            <span id="exciseDuty" style="margin-left: 3%;"  class="_span">{{purchaseHeaderObj.exciseChargeAmount}} </span>
            <br/>
            <label for="nontaxable">Non-taxable:</label>
            <span id="nontaxable" style="margin-left: 5%;" class="_span">{{(purchaseHeaderObj.nonTaxableAmount).toFixed(4)}}</span>
            <br/>
            <label for="taxable">Taxable:</label>
            <span id="taxable" style="margin-left: 11%;" class="_span">{{(purchaseHeaderObj.taxableAmount).toFixed(4)}}</span>
            <br/>
            <label for="tax">Tax(13%):</label>
            <span id="tax" style="margin-left: 9%;" class="_span">{{(purchaseHeaderObj.vatAmount).toFixed(4)}}</span>
            <br/>
            <label for="total">Total:</label>
            <span id="total" style="margin-left: 15%;" class="_span">{{(purchaseHeaderObj.totalBillAmount).toFixed(4)}}</span>
            <br/>
        </div>
       <div class="box-footer" style="margin-top: 12%;">
          <!-- <Button class="p-button-raised p-button-warning" icon="pi pi-refresh" style="margin-top: 10px;float: right;margin-left: 100%;"  @click.prevent="$router.back()">Back</Button> -->
      <Button   @click.prevent="$router.back()" class="p-button-raised" style="margin-top: 10px;float: right;margin-left: 100%;" icon="pi pi-refresh" label="Back"/>
      </div>
   </div>
   <Dialog header="Purchase Batch Details"  :modal="true" :visible.sync="showPosDialog" 
       :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
              <label for="name">Batch Name: <span style="color:red">*</span></label>
              <span>{{this.batch}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="shortName">Bonus: </label>
               <span>{{this.bonus}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="manufactureDate">Manufacture Date: "</label>
               <span>{{this.manufactureDate}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="expiryDate">Expiry Date: </label>
               <span>{{this.expiryDate}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="shortName">Free Qty: </label>
              <span>{{this.freeQty}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="ccPercentage">Cc Percentage: </label>
              <span>{{this.ccPercentage}}</span>
            </div>
           </div>
        <template #footer>
            <Button class="p-button-raised p-button-rounded" @click.prevent="cancel" label="Back"/>
            <!-- <Button @click.prevent="closeBasicBatchDetails" class="p-button-raised p-button-danger"
            label="Cancel"/> -->
        </template>
      </Dialog>
        </div>
    </section>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
export default {
  name: 'assignDetailReport',
  props: ['purchaseHeaderObj'],
  data() {
    return {
      inventoryInOutDetailList: [],
      extraExpensesList: [],
      showPosDialog: false,
      bonus: '',
      freeQty: 0,
      batch: '',
      ccPercentage: 0,
      expiryDate: '',
      manufactureDate: ''
    }
  },
  created() {
    this.searchInventoryInDetail()
    this.extraExpenseList()
  },
  methods: {
    async searchInventoryInDetail() {
      if (this.purchaseHeaderObj === undefined) {
        this.$router.back()
        return
      }
      let resp = await this.$store.dispatch('loadOutInventoryDetail', this.purchaseHeaderObj.id)
      if (resp.data.status === 'SUCCESS') {
        this.inventoryInOutDetailList = resp.data.data
      }
    },
    async extraExpenseList() {
      let resp = await this.$store.dispatch('extraExpensesSalesList', this.purchaseHeaderObj.id)
      if (resp !== undefined) {
        if (resp.data.status === 'SUCCESS') {
          this.extraExpensesList = resp.data.data
        }
      }
    },
    cancel() {
      this.showPosDialog = false
    },
    async posDetail(po) {
      this.batch = po.batch
      this.ccPercentage = po.ccPercentage
      this.freeQty = po.freeQty
      this.bonus = po.bonus
      this.expiryDate = po.expiryDate
      this.manufactureDate = po.manufactureDate
      this.showPosDialog = true
    }
  },
  components: {
    Button,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// salesDetailsDairyReport.vue?4a7e6f4e